export enum IndicatorActionType {
  RUNEXE = 'RunExe',
  OPENURL = 'OpenURL',
  SPAWNSCRIPT = 'SpawnScript',
  SIGNALSCRIPT = 'SignalScript',
  SHOWCUSTOMFORM = 'ShowCustomForm',
}
